module.exports = __webpack_public_path__ + "GLOBALS/images/mejs-controls.svg";